import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FacebookWhite = forwardRef<SVGSVGElement, IconProps>(({ size = 20 }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 36"
      fill="none"
      ref={forwardedRef}
    >
      <g filter="url(#a)">
        <path
          fill="#fff"
          d="M16.727 7.27a10.834 10.834 0 0 1 3.18 21.432v-7.57h2.524l.48-3.133h-3.005v-2.031c0-.107.007-.214.02-.319.029-.21.088-.412.184-.593a1.42 1.42 0 0 1 .174-.255 1.351 1.351 0 0 1 .544-.381c.058-.023.118-.044.182-.062.19-.053.41-.083.662-.083h1.365v-2.667a17.403 17.403 0 0 0-1.98-.202l-.444-.008c-2.085 0-3.56 1.063-3.973 3.022a5.77 5.77 0 0 0-.12 1.193V18h-2.75v3.133h2.75v7.57a10.832 10.832 0 0 1-5.343-18.938 10.833 10.833 0 0 1 5.55-2.494Z"
        />
      </g>
      <defs>
        <filter
          id="a"
          width="46"
          height="46"
          x="-5"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5481_112979" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_5481_112979" result="shape" />
        </filter>
      </defs>
    </svg>
  )
})
